import { render, staticRenderFns } from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=template&id=601273c0&scoped=true&"
import script from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=style&index=0&id=601273c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601273c0",
  null
  
)

export default component.exports